import { render, staticRenderFns } from "./notificationEdit.vue?vue&type=template&id=3b549d49&scoped=true"
import script from "./notificationEdit.vue?vue&type=script&lang=js"
export * from "./notificationEdit.vue?vue&type=script&lang=js"
import style0 from "./notificationEdit.vue?vue&type=style&index=0&id=3b549d49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b549d49",
  null
  
)

export default component.exports